import axiosClient from "./axiosClient";

export const listarCuentas = () => axiosClient.get("/cuentas-bancarias").then((r) => r.data);
export const upsertCuentaPropia = (data) => axiosClient.post("/cuentas-bancarias/propia", data).then((r) => r.data);
export const eliminarCuenta = (id) => axiosClient.delete(`/cuentas-bancarias/${id}`).then((r) => r.data);
export const fijarSaldoInicial = (cuentaId, saldoActual) =>
  axiosClient.put(`/cuentas-bancarias/${cuentaId}/saldo-inicial`, { saldoActual });
export const registrarPagoTarjeta = (cuentaId, monto) =>
  axiosClient.post(`/cuentas-bancarias/${cuentaId}/pago-tarjeta`, { monto });
export const guardarOrden = (tipo, cuentaIds) =>
  axiosClient.post("/cuentas-bancarias/orden", { tipo, cuentaIds });
